import { LicenseType } from '@/models/company';

/**
 * Returns the license type code value.  If the license type is
 * already a string, passes it through since some custom or
 * legacy implementations rely on this value being passed directly
 * to the root stash component for parsing.
 */
export const getLicenseTypeCode = (licenseType: LicenseType | string) => {
  return typeof licenseType === 'string' ? licenseType : licenseType.typeCode ?? licenseType.type;
};
